import { graphql } from 'react-relay';

import { type FragmentRef } from '@confluence/apollo-relay-interop/entry-points/useFragmentizedQuery.ts';
import { useFragmentizedFragment } from '@confluence/apollo-relay-interop/entry-points/useFragmentizedFragment.ts';

import type { ContentTypesHeaderQueryNode } from './ContentTypesHeader.tsx';
import type { useContentBasicInfoFragment$data } from './__generated__/useContentBasicInfoFragment.graphql.ts';

type ContentBasicInfo = Omit<useContentBasicInfoFragment$data, ' $fragmentType'>;
export const useContentBasicInfo = (
	contentBasicInfoRef: FragmentRef,
	externalShareContent?: ContentTypesHeaderQueryNode | null,
): ContentBasicInfo | null => {
	if (externalShareContent) {
		return {
			id: externalShareContent.id,
			title: externalShareContent.title,
			type: externalShareContent.type,
			// @ts-expect-error - FIXME: This error was surfaced after enabling the `typescriptExcludeUndefinedFromNullableUnion`
			// Relay compiler option. Previously, `undefined` was incorrectly included in nullable unions in generated types; this option removes it. The owning team should fix this properly.
			subType: externalShareContent.subType,
			status: externalShareContent.status,
		};
	}

	// eslint-disable-next-line react-hooks/rules-of-hooks
	return useFragmentizedFragment<ContentBasicInfo>(
		graphql`
			fragment useContentBasicInfoFragment on Content {
				id
				title
				type
				subType
				status
			}
		`,
		contentBasicInfoRef,
	);
};
